import { Injectable, NgZone } from '@angular/core';
 
@Injectable()

export class IdleService {

  private timeoutId: any;

  private readonly timeoutMillis = 30 * 60 * 1000; // 30 minutes
 
  constructor(private zone: NgZone) {}
 
  startWatching(onTimeout: () => void): void {

    this.resetTimer(onTimeout);
 
    const activityEvents = ['mousemove', 'keydown', 'click', 'touchstart'];
 
    activityEvents.forEach(event => {

      document.addEventListener(event, () => this.resetTimer(onTimeout));

    });

  }
 
  private resetTimer(onTimeout: () => void): void {

    if (this.timeoutId) {

      clearTimeout(this.timeoutId);

    }
 
    this.timeoutId = setTimeout(() => {

      this.zone.run(() => {

        onTimeout();

      });

    }, this.timeoutMillis);

  }

}
 


// WEBPACK FOOTER //
// /app/src/app/services/idle.service.ts